import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="grv-beitrag"
export default class extends Controller {
	static targets = ["nominal"]

	connect() {}

	updateModus({ currentTarget }) {
		this.nominalTarget.classList.add("hidden")

		switch (currentTarget.value) {
			case "prozentual":
				break
			case "nominal":
				this.nominalTarget.classList.remove("hidden")
				break
		}
	}
}
